import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { faAt } from "@fortawesome/free-solid-svg-icons";
import avatar from "../img/eden-developer.png";
import PageContent from "./UI/PageContent";

const STATS = [
  { value: "6+", label: "Years experience", detail: "in startups & scaleups" },
  { value: "Fullstack", label: "Developer", detail: "web & mobile" },
  { value: "FR", label: "Based in France", detail: "full remote" },
];

function Intro() {
  const words = ["Product Strategy", "Business Impact", "Clean Code", "Design"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [words.length]);

  return (
    <PageContent className="min-h-[calc(100vh-4rem)] md:min-h-screen flex flex-col justify-center !py-10 md:!py-16">
      <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-14">
        <img
          className="w-40 h-40 md:w-48 md:h-48 rounded-full object-cover shrink-0 ring-1 ring-[#EEF2FF]/60 shadow-[0_8px_32px_rgba(61,44,141,0.12)]"
          src={avatar}
          alt="Eden C. Louis"
        />

        <div className="flex flex-col gap-8 lg:gap-10 w-full max-w-xl lg:max-w-none">
          <div className="flex flex-col gap-2 text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold leading-[1.1]">
              Hi I&apos;m <span className="gradient-text-purple">Eden </span> 👋 🌈
            </h1>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold leading-[1.1]">
              a Software Engineer
            </h1>
          </div>

          <p className="text-base md:text-lg leading-relaxed text-ink text-center lg:text-left max-w-md lg:max-w-lg mx-auto lg:mx-0">
            A french product-driven fullstack developer building user-friendly websites
            and apps, with a strong focus on{" "}
            <span className="inline-block relative overflow-hidden h-7 align-bottom min-w-[11rem]">
              <span
                className="block transition-transform duration-700 ease-in-out"
                style={{ transform: `translateY(-${index * 1.75}rem)` }}
              >
                {words.map((word, i) => (
                  <span
                    key={word}
                    className={`block h-7 leading-7 font-semibold ${i % 2 === 0 ? "gradient-text-purple" : "gradient-text-blue"}`}
                  >
                    {word}.
                  </span>
                ))}
              </span>
            </span>
          </p>

          <div className="flex flex-row gap-3 justify-center lg:justify-start">
            <a
              href="https://github.com/Ed-Ls"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-12 w-12 items-center justify-center rounded-2xl glass-card hover:bg-[#EEF2FF]/40 transition-colors"
              aria-label="GitHub"
            >
              <FontAwesomeIcon icon={faGithub} className="text-2xl text-ink" />
            </a>
            <a
              href="https://www.linkedin.com/in/e-c-ls/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-12 w-12 items-center justify-center rounded-2xl glass-card hover:bg-[#EEF2FF]/40 transition-colors"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedin} className="text-2xl text-ink" />
            </a>
            <a
              href="mailto:eden.louis13@gmail.com"
              className="flex h-12 w-12 items-center justify-center rounded-2xl glass-card hover:bg-[#EEF2FF]/40 transition-colors"
              aria-label="Email"
            >
              <FontAwesomeIcon icon={faAt} className="text-2xl text-ink" />
            </a>
          </div>

          <div className="glass-card w-full overflow-hidden">
            <div className="grid grid-cols-3 divide-x divide-[#E7E7E7]/50">
              {STATS.map((stat) => (
                <div key={stat.label} className="px-3 sm:px-5 py-5 sm:py-6 text-center lg:text-left">
                  <p className="text-lg sm:text-xl font-bold gradient-text-purple">{stat.value}</p>
                  <p className="text-xs sm:text-sm font-semibold text-ink mt-1">{stat.label}</p>
                  <p className="text-[10px] sm:text-xs text-muted mt-0.5 hidden sm:block">{stat.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PageContent>
  );
}

export default Intro;
